import { MicModeToggleVariant } from "../components/useroverlay/MicModeToggle";

export type WaveformMode = 'overlay' | 'replace';

export interface GUIThemeProperties {
  // Mic button behavior
  micStaticText: string | null;
  micVolatile: boolean;
  showMicIcon: boolean;

  // Feature flags
  allowLiveMic: boolean;
  showPlayPause: boolean;

  // Component variants
  micModeToggleVariant: MicModeToggleVariant;
  waveformMode: WaveformMode;
}

export const GUI_THEMES_CONFIG = {
  original: {
    micStaticText: null,
    micVolatile: true,
    showMicIcon: false,
    allowLiveMic: false,
    showPlayPause: false,
    micModeToggleVariant: 'switch',
    waveformMode: 'overlay',
  },
  arcade: {
    micStaticText: "Press and Hold to Talk",
    micVolatile: false,
    showMicIcon: true,
    allowLiveMic: false,
    showPlayPause: false,
    micModeToggleVariant: 'switch',
    waveformMode: 'overlay',
  },
  complex1: {
    micStaticText: null,
    micVolatile: true,
    showMicIcon: false,
    allowLiveMic: true,
    showPlayPause: true,
    micModeToggleVariant: 'button',
    waveformMode: 'replace',
  },
  complex2: {
    micStaticText: null,
    micVolatile: true,
    showMicIcon: false,
    allowLiveMic: true,
    showPlayPause: true,
    micModeToggleVariant: 'button',
    waveformMode: 'replace',
  },
} as const satisfies Record<string, GUIThemeProperties>;

// Derive the GUITheme type from the config object keys
const GUI_THEME_KEYS = Object.keys(GUI_THEMES_CONFIG) as Array<keyof typeof GUI_THEMES_CONFIG>;
export type GUITheme = typeof GUI_THEME_KEYS[number];

// Helper to get all available GUI styles
export function getAvailableGUIThemes(): GUITheme[] {
  return GUI_THEME_KEYS as GUITheme[];
}

// Get GUI style properties with fallback
export function getGUIThemeProperties(style: GUITheme): GUIThemeProperties {
  const props = GUI_THEMES_CONFIG[style];
  if (props) {
    return props;
  }

  // Fallback to original if style not found
  return GUI_THEMES_CONFIG['original'];
}

export interface AppConfig {
  tenantName: string;
  enableStytch: boolean;
  enableNativeBridge: boolean;
  showUserLoginStatus: boolean;
  enableSidePanel: boolean;
  enableStandardFeedbackButton: boolean;

  guiTheme: GUITheme;
}

export const defaultAppConfig: AppConfig = {
  tenantName: 'Persona',
  enableStytch: true,
  enableNativeBridge: true,
  showUserLoginStatus: true,
  enableSidePanel: true,
  enableStandardFeedbackButton: true,

  guiTheme: 'original',
};
